interface StoreOrderCashBalance {
  amount: string
  remitted_amount: string
  shortfall_amount: string
}

export function cashRemaining(collection: StoreOrderCashBalance) {
  const amount = Number(collection.amount)
  const remitted = Number(collection.remitted_amount)
  const shortfall = Number(collection.shortfall_amount)
  if (![amount, remitted, shortfall].every(Number.isFinite)) return 0

  const pendingInCents =
    Math.round(amount * 100) -
    Math.round(remitted * 100) -
    Math.round(shortfall * 100)

  return Math.max(pendingInCents, 0) / 100
}
